"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M15 5v-.5A1.5 1.5 0 0 0 13.5 3h-3A1.5 1.5 0 0 0 9 4.5V5H4.5a.5.5 0 0 0 0 1H6v12.5A2.5 2.5 0 0 0 8.5 21h7a2.5 2.5 0 0 0 2.5-2.5V6h1.5a.5.5 0 0 0 0-1zm-4.5-1h3a.5.5 0 0 1 .5.5V5h-4v-.5a.5.5 0 0 1 .5-.5m.5 4.5v9a.5.5 0 0 1-1 0v-9a.5.5 0 0 1 1 0m3 0v9a.5.5 0 0 1-1 0v-9a.5.5 0 0 1 1 0"
}), 'TrashcanFilled');
